<template>
    <el-row class="container_self">
        <h3>App渠道列表</h3>
        <el-row class="table_parent">
            <!-- <el-row> <el-row class="add_btn"><el-button type="primary" icon="el-icon-plus" size="mini" @click="saveAppChannel">新增App渠道</el-button></el-row></el-row> -->
            <el-row class="add_btn"><el-button type="success" icon="el-icon-plus" size="mini" @click="addChannel">新增渠道</el-button></el-row>
            
            <el-form :model="searchForm" size="mini" style="margin:20px 0" :inline="true">
                <el-form-item label="渠道ID">
                    <!-- <el-input v-model="searchForm.channelId" placeholder="请输入渠道ID" clearable></el-input> -->
                    <el-select v-model="searchForm.channelId" placeholder="请选择渠道ID" clearable>
                        <el-option v-for="(tpl,ind) in appChannelList" :value="tpl.channelId" :label="tpl.channelName" :key="ind"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="app包名">
                    <!-- <el-input v-model="searchForm.packageName" placeholder="请输入app包名" clearable></el-input> -->
                    <el-select v-model="searchForm.packageName" placeholder="请选择App" clearable>
                        <el-option v-for="(appItem,appIndex) in appList" :value="appItem.packageName" :label="`${appItem.appName}（${appItem.customerName}）`" :key="appIndex+'_add'"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="warning" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-table  :data="appChannelList" v-loading="loading">
                <el-table-column label="ID" prop="id" align="center" width="80"></el-table-column>
                <el-table-column label="客户名称" prop="customerName" align="center" width="120"></el-table-column>
                <el-table-column label="app名称" prop="appName" align="center"></el-table-column>
                <el-table-column label="app包名" prop="packageName" align="center"></el-table-column>
                <el-table-column label="渠道号ID" prop="channelId" align="center"></el-table-column>
                <el-table-column label="渠道名称" prop="channelName" align="center"></el-table-column>
                <el-table-column label="渠道说明" prop="description" align="center"></el-table-column>
                <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="300" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="success" size="mini" @click="updateChannel(scope.row)">更新</el-button>
                        <el-button type="warning" size="mini" @click="addChannelUrl(scope.row.channelId)">添加渠道链接</el-button>
                        <el-button type="danger" size="mini" @click="deleteChannel(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>


            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchForm.currentPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="searchForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
            </el-pagination>
        </el-row>

        <el-dialog :title="string+'渠道'" :visible.sync="dialogFormVisible">
            <el-form :model="addChannelForm" :rules="rules" ref="ruleForm">
                <el-form-item label="所对应App" :label-width="formLabelWidth" prop="packageName">
                   <el-select v-model="addChannelForm.packageName" placeholder="请选择所对应App" clearable style="width:60%">
                     <el-option v-for="(item,index) in appList" :value="item.packageName" :label="`${item.appName}（${item.customerName}）`" :key="index"></el-option>
                   </el-select>
                </el-form-item>
                <el-form-item label="渠道ID" :label-width="formLabelWidth" prop="channelId">
                    <el-input v-model="addChannelForm.channelId" autocomplete="off" clearable placeholder="请输入渠道ID"></el-input>
                </el-form-item>
                <el-form-item label="渠道名称" :label-width="formLabelWidth" prop="channelName">
                    <el-input v-model="addChannelForm.channelName" autocomplete="off" clearable placeholder="请输入渠道名称"></el-input>
                </el-form-item>
                <el-form-item label="是否启用" :label-width="formLabelWidth">
                   <el-select v-model="addChannelForm.enabled" placeholder="请选择是否启用此渠道" clearable style="width:60%">
                        <el-option :value="1" label="启用"></el-option>
                        <el-option :value="0" label="不启用"></el-option>
                   </el-select>
                </el-form-item>
                <el-form-item label="其他说明" :label-width="formLabelWidth" prop="extra">
                    <el-input v-model="addChannelForm.description" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitChannel('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    <el-dialog title="添加链接" :visible.sync="dialogFormVisible1">
             <el-form :model="addUrlForm" :rules="rules1" ref="ruleForm1">
                 <el-form-item label="渠道ID" :label-width="formLabelWidth">
                     <el-input v-model="addUrlForm.channelId" autocomplete="off" placeholder="请输入链接ID" disabled></el-input>
                 </el-form-item>
                 <el-form-item label="链接" :label-width="formLabelWidth" prop="webUrl">
                     <el-input v-model="addUrlForm.webUrl" autocomplete="off" placeholder="请输入链接名称"></el-input>
                 </el-form-item>
                 <el-form-item label="是否启用" :label-width="formLabelWidth">
                    <el-select v-model="addUrlForm.enabled" placeholder="请选择是否启用此链接" clearable>
                         <el-option :value="1" label="启用"></el-option>
                         <el-option :value="0" label="不启用"></el-option>
                    </el-select>
                 </el-form-item>
             </el-form>
             <div slot="footer" class="dialog-footer">
                 <el-button @click="dialogFormVisible1 = false">取 消</el-button>
                 <el-button type="primary" @click="submitUrl('ruleForm1')">确 定</el-button>
             </div>
      </el-dialog>
    </el-row>
</template>


<script>
import { axiosGet,axiosPost } from "@/assets/ajaxFn.js";
    export default {
        data(){
            return{
                appList:[],
                appChannelList:[],
                loading:false,
                searchForm:{
                    channelId:'',
                    packageName:'',
                    currentPage:1,
                    pageSize:20
                },
                total:0,
                dialogFormVisible:false,
                formLabelWidth:'120px',
                addChannelForm:{
                    channelId:"",
                    channelName:"",
                    enabled:1,
                    description:"",
                    packageName:""
                },
                string:"新增",
                rules:{
                    channelId: [
                        { required: true, message: '请输入渠道ID', trigger: 'blur' },
                        { pattern: /^[^\u4e00-\u9fa5]+$/, message: '渠道ID不能包含中文字符', trigger: 'blur' }
                    ],
                    description: [
                        { required: true, message: '请输入渠道说明', trigger: 'blur' }
                    ],
                    channelName:[
                        { required: true, message: '请输入渠道名称', trigger: 'blur' }
                    ],
                    packageName:[
                        { required: true, message: '请选择app包名', trigger: 'blur' }
                    ]
                },
                isEdit:false,
                addUrlForm:{
                    "channelId": "",
                    "enabled": 1,
                    "webUrl": ""
                },
                dialogFormVisible1:false,
                rules1:{
                    webUrl:[
                        { required: true, message: '请输入链接名称', trigger: 'blur' }
                    ]
                }
            }
        },
        methods:{
            handleSizeChange(val){
                this.searchForm.pageSize=val;
                this.getAppChannelList(this.searchForm);
            },
            handleCurrentChange(val){
                this.searchForm.currentPage=val;
                this.getAppChannelList(this.searchForm);
            },
            deleteChannel(id){
                this.$confirm('此操作将永久删除该渠道, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        axiosPost('/api/app_channel/delete',{id:id},"JSON").then(res=>{
                            if(res.code==0){
                                this.$message({message:'渠道删除成功',type:'success'});
                                this.getAppChannelList({})
                            }
                        })
                    }).catch(() => { });
               
            },
            getAppChannelList(params){
                this.loading=true;
                axiosGet('/api/app_channel/list',{currentPage:1,packageName:params.packageName||"",pageSize:params.pageSize||20,channelId:params.channelId||""}).then(res=>{
                    if(res.code==0){
                        this.total=res.data.total;
                        this.appChannelList=res.data.records;
                        this.loading=false;
                    }else{
                        this.loading=false;
                    }
                })
            },
            addChannel(){
                this.dialogFormVisible=true;
                if(this.$refs.ruleForm){
                    this.$refs.ruleForm.resetFields();// 重置表单验证
                }
                this.string="新增";
                this.isEdit=false;
                this.addChannelForm={
                    channelId:"",
                    channelName:"",
                    enabled:1,
                    description:"",
                    packageName:""
                };
                
                
            },
            search(){
                this.getAppChannelList(this.searchForm);
            },
            getAppList(){
                axiosGet('/api/app_web/list').then(res=>{
                if(res.code==0){
                    this.appList=res.data.records;
                }
                })
            },
            async submitChannel(formName) {
                const valid = await new Promise((resolve) => {
                    this.$refs[formName].validate((valid) => {
                        resolve(valid);
                    });
                });

                if (valid) {
                    const url = this.isEdit ? '/api/app_channel/update' : '/api/app_channel/add';
                    await axiosPost(url, this.addChannelForm, 'JSON').then(async (res) => {
                        if (res.code === 0) {
                            const message = this.isEdit ? '渠道更新成功' : '渠道新增成功';
                            this.$message({ message: message, type: 'success' });
                            this.dialogFormVisible = false;
                            this.getAppChannelList({});
                        }
                    });
                }
            },
            updateChannel(row){
                this.dialogFormVisible=true;
                this.isEdit=true;
                this.addChannelForm={
                    channelId:row.channelId,
                    enabled:row.enabled||1,
                    description:row.description,
                    channelName:row.channelName,
                    packageName:row.packageName,
                    id:row.id
                };
            },
            addChannelUrl(channelId){
                this.dialogFormVisible1=true;
                this.addUrlForm.channelId=channelId;

            },
            submitUrl(formName){
                this.$refs[formName].validate((valid) => {
                if (valid) {
                   axiosPost('/api/channel/add_url', this.addUrlForm, 'JSON').then(res => {
                         if (res.code === 0) {
                            this.$message({ message: '链接新增成功', type: 'success' });
                            this.dialogFormVisible1 = false;
                            this.getAppChannelList({});
                            // this.geturlList(this.searchForm);
                         }
                   });
                }
             });
            }   
        },
        mounted(){
            this.getAppChannelList({});
            this.getAppList();
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/view/AppManager/AppChannelManager.vue